<template>
  <div class="order-info-block">
    <h2 class="section-title">{{blockTitle}}</h2>
    <div class="content lateral-sub-padding">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'order-info-block',
    props: [
      'block-title'
    ]
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .order-info-block {
    .content {
      line-height: 1.5;
      padding-bottom: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// OrderInfoBlock.vue?33d826fe